import { useClientFlag } from "@/lib/ui/use-client-flag";

function readKitsCopilotFlag(): boolean {
    if (typeof window === "undefined") return true;
    try {
        const stored = window.localStorage.getItem("kits-copilot");
        if (stored === "1") return true;
        if (stored === "0") return false;
    } catch {}
    return import.meta.env.VITE_PUBLIC_KITS_COPILOT !== "false";
}

export function useKitsCopilotEnabled(): boolean {
    return useClientFlag(readKitsCopilotFlag);
}
